// Vendor
import $ from 'jquery';
import Hammer from 'hammerjs';
import Helpers from 'helpers/util';

// Elements
let $el = $('.js-carousel');

const SCROLLBAR_OFFSET = 50;
let offset = 0;
let scrollbarWidth = 50;

class Carousel {
	constructor($el) {
		this.$el = $el;

		this.$container = $el.find('.carousel-container');
		this.$inner = $el.find('.carousel-inner');
		this.$item = $el.find('.carousel-item');
		this.$currentActiveEl = $el.find('.carousel-item.active');
		this.$itemWrapper = $el.find('.carousel-nowrap');
		this.$scrollbar = $el.find('.carousel-scrollbar');
		this.$scrollTrack = $el.find('.carousel-scrollbar-track');
		this.$subNavContainer = $el.find('.sub-nav-inline');
		this.$aTags = $el.find('a');

		// Variables for HammerJS
		this.curDown = false;
		this.curXPos = 0; // Desktop: mouse cursor
		this.curXScrollbarPos = 0; // Red scrollbar

		// Variables for custom scrollbar
		this.containerWidth = 0;
		this.maxX = 0;
		this.scrollbarPerc = 0;
		this.isVisible = false;

		// Variables for hover
		this.isActive = false;
		this.$activeEl;

		this.clsHasScroll = 'has-scrollbar';
		this.clsHasHover = 'has-hover';
		this.clsIsAnimating = 'is-animating';

		this.clsIsActive = 'is-active';
		this.clsFront = 'is-front';

		this.setupSubNav();
		this.attachEvents();

		if (!window.Modernizr.touch) {
			this.attachGrabber();
		}
	}

	attachEvents() {
		this.doLayout();
		this.hideNativeScrollbar();
		this.scrollbarLayout();
		this.preventLinkOnScroll();

		// fix for carousel items that are href links
		this.$item.on('mousedown', (event)=>{
			event.preventDefault();
		});

		var _currentActive = this.$currentActiveEl;
		var _inner = this.$inner;
		var _itemWrapper = this.$itemWrapper;

		$(function() {
			setTimeout(() => {
				if (_currentActive.length > 0) {
					if (window.matchMedia('(max-width: 767.98px)').matches) {
						_inner[0].scrollLeft = _currentActive[0].offsetLeft - _itemWrapper[0].offsetLeft
					} else {
						_inner[0].scrollLeft = _currentActive[0].offsetLeft - _itemWrapper[0].offsetLeft - 70
					}
				}
			}, 0)
		})

		$(window).on('resize', () => {
			this.doLayout();
			this.scrollbarLayout();
			this.scrollbarTrackHandler();
		});

		this.$inner.on('scroll', () => {
			this.scrollbarTrackHandler();
		});

		if (!window.Modernizr.touch) {
			this.attachHoverHandlers();
		}

		if ( this.$scrollbar.length > 0 ) {
			this.attachScrollbarHandler();
		}
	}

	attachHoverHandlers() {
		this.$item.on('mouseenter', (ev) => {
			let currentTarget = $(ev.currentTarget);
			this.$activeEl = $(ev.currentTarget);
			if (!this.isActive) {
				currentTarget.addClass(this.clsIsActive);
				this.isActive = true;
			}
		});

		this.$item.on('mouseleave', () => {
			this.$activeEl = null;
		});

		Helpers.dom.onTransitionEndAlways(this.$item,() => {
			this.$item.removeClass(this.clsIsActive);
			if (this.$activeEl) {
				this.$activeEl.addClass(this.clsIsActive);
			} else {
				this.$item.removeClass(this.clsIsActive);
				this.isActive = false;
			}
		});

	}

	setupSubNav(){
		// setup sub nav arrows

		if ( this.$subNavContainer.length > 0 ) {
			this.$el.addClass('has-nav');
			this.$el.prepend(
				`<div class="carousel-nav carousel-prev">
					<icon class="icon icon-chevron-left"></icon>
				</div>`
			);
			this.$el.append(
				`<div class="carousel-nav carousel-next">
					<icon class="icon icon-chevron-right"></icon>
				</div>`
			);

			// bindings for scroll nav
			this.$el.find('.carousel-next').on('click', () => {
				this.scrollChild('next');
			});

			this.$el.find('.carousel-prev').on('click', () => {
				this.scrollChild('prev');
			});
		}
	}

	getInnerWidth() {
		//let itemWidth = this.$item.eq(0)[0].getBoundingClientRect().width;
		//let itemX = Math.abs(this.$item.eq(0).offset().left + this.$inner.scrollLeft());
		//return (itemWidth * this.$item.length) + (itemX * 2);
		return this.$item.eq(0).width() * this.$item.length;
	}

	isHScrollable( element ){
		return element[0].scrollWidth > element[0].clientWidth;
	}

	// On scroll of $inner, move the scrollbar
	scrollbarTrackHandler() {
		if (!this.isVisible) {
			return false;
		}
		let perc = 100 - this.scrollbarPerc;
		let xPerc = (this.$inner.scrollLeft() / this.maxX) * 100;

		let x = (xPerc / 100) * perc;
		this.$scrollTrack.css('left', `${x}%`);
	}

	scrollbarLayout() {
		this.containerWidth = this.getInnerWidth();
		this.scrollbarPerc = ($(window).innerWidth() / this.containerWidth) * 100;
		this.maxX = Math.abs(this.containerWidth - $(window).innerWidth());

		this.isVisible = (this.containerWidth > $(window).innerWidth()) ? true : false;

		if (this.isVisible) {
			this.$el.addClass(this.clsHasScroll);
			this.$scrollTrack.css('width', `${this.scrollbarPerc}%`);
		} else {
			this.$el.removeClass(this.clsHasScroll);
		}
	}

	preventLinkOnScroll(){
		// prevent accidental link clicking when drag scrolling
		this.$aTags
			.on('click', (event)=>{
				let shiftAmount = Math.abs(this.linkDownX - this.linkUpX);
				if ( shiftAmount > 10 ) {
					event.preventDefault();
				}
			})
			.on('mousedown', (event)=>{
				this.linkDownX = event.pageX;
			})
			.on('mouseup', (event)=>{
				this.linkUpX = event.pageX;
			})
			.on('touchstart', (event)=>{
				this.linkDownX = event.pageX;
			})
			.on('touchend', (event)=>{
				this.linkUpX = event.originalEvent.changedTouches[0].pageX;
			});
	}

	// On move of scrollbar, move $inner
	attachScrollbarHandler() {
		let mouseDown = (window.Modernizr.touch) ? 'touchstart' : 'mousedown';

		this.$el.on(mouseDown, () => {
			this.curXScrollbarPos = this.$inner.scrollLeft();
		});

		let hammertime = new Hammer(this.$scrollTrack.get(0));
		hammertime.on('panleft panright', (ev) => {
			let targetX = this.curXScrollbarPos + (ev.deltaX * 2);
			this.$inner.scrollLeft(targetX);
		});
	}

	// Desktop grab on $inner
	attachGrabber() {
		let hammertime = new Hammer(this.$inner.get(0));
		hammertime.on('panleft panright', (ev) => {
			this.$inner.scrollLeft(this.curXPos - ev.deltaX);
		});

		this.$el.on('mouseup', () => {
			this.curDown = false;
		});

		this.$el.on('mousedown', () => {
			this.curDown = true;
			this.curXPos = this.$inner.scrollLeft();
		});
	}

	doLayout() {
		this.$container.css('height', '');
		let PADDING = parseInt(this.$inner.css('padding-top')) * 2;
		let height = this.$itemWrapper.outerHeight() + PADDING;

		// console.log(`itemWrapper: ${this.$itemWrapper.outerHeight()} - height: ${height} - outerHeight: ${this.$container.outerHeight()} - PADDING: ${PADDING}`);

		if (this.$container.outerHeight() !== height ) {
			this.$container.css('height', height  );
		}

		if ( this.isHScrollable( this.$inner ) ) {
			this.$el.removeClass('no-overflow');
		} else {
			this.$el.addClass('no-overflow');
		}

	}

	// Measure height of scrollbar, then offset
	hideNativeScrollbar() {
		let scrollDiv = document.createElement('div');
		scrollDiv.className = 'scrollbar-measure';
		document.body.appendChild(scrollDiv);
		scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
		offset = (scrollbarWidth) ? SCROLLBAR_OFFSET - scrollbarWidth : 0;
		document.body.removeChild(scrollDiv);

		this.$inner.css('height', `calc(100% + ${offset}px)`);
	}

	scrollChild(direction) {
		let itemWidth = this.$item.width();
		itemWidth = 2 * parseInt( this.$item.css('marginRight')) + itemWidth + 70;

		if (direction === 'prev') {
			itemWidth = -itemWidth;
		}

		this.$inner.animate({
			scrollLeft: this.$inner.scrollLeft() + itemWidth
		});
	}
}

const _init = () => {
	$el.each(function(){
		new Carousel($(this));
	});
};

_init();
